<div class="agpr-recipientReport-mppAdjustedEstimates">
    <agpr-checkbox
        id="distributions_recipient_enableMppEstimates"
        label="Discover.distribution.statistics.mppAdjustedEstimates"
        [binary]="true"
        [(ngModel)]="_enableMppEstimates"
        (ngModelChange)="setUniqueOpensCount()"
    >
        <a
            agprTooltip="Discover.distribution.statistics.mppAdjustedEstimates.info"
            [escape]="false"
            role="img"
            class="fa-regular fa-circle-info agpr-recipientReport-mppAdjustedEstimates-tooltip"
            [interactiveTooltip]="true"
            href="https://help.agilitypr.com/en/articles/6816484-agility-email-reporting-with-apple-mail-privacy-protection"
            target="_blank"
        ></a>
    </agpr-checkbox>
</div>

@if(isScheduled && (status === statisticsResourceStatus.scheduled || status === statisticsResourceStatus.pending)) {
    <agpr-message
        [severity]="messageSeverities.info"
    >
        {{ (isDistribution ? 'Discover.distributionReport.scheduledNotice' : 'Discover.briefingReport.scheduledNotice') | localize}}{{sentDate | changeTimeZone: userTimeZone: 'MMMM D, YYYY h:mm A z'}}
        <ng-container *ngIf="userTimeZone !== 'UTC'">
            {{'(UTC'}}{{sentDate | changeTimeZone: userTimeZone: 'Z)'}}
        </ng-container>
    </agpr-message>
}

@if(!recipientReportData || status === statisticsResourceStatus.pending) {
    <!-- Placeholder while we wait for events to arrive -->
    <div
        class="agpr-reportPlaceholder"
    >
        <div class="agpr-reportPlaceholder-mainContainer">
            <span class="fa-duotone fa-regular fa-chart-line-up noContentIcon"></span>
            <ng-container *ngIf="!isRSSFeed">
                <div *ngIf="status === statisticsResourceStatus.scheduled">
                    @if (isDistribution) {
                        <div class="mainText">{{'Discover.distributionReport.reportPlaceholder.unsent' | localize}}</div>
                        <div>{{'Discover.distributionReport.reportPlaceholder.unsent.details' | localize}}</div>
                    } @else {
                        <div class="mainText">{{'Discover.briefingsReport.reportPlaceholder.unsent' | localize}}</div>
                        <div>{{'Discover.briefingsReport.reportPlaceholder.unsent.details' | localize}}</div>
                    }
                </div>
                <div *ngIf="status !== statisticsResourceStatus.scheduled && !dataNotAvailable">
                    <div class="mainText">{{placeholderTitle| localize}}</div>
                    <div>{{'Discover.distributionReport.reportPlaceholder.sent.details' | localize}}</div>
                </div>
                <div *ngIf="status !== statisticsResourceStatus.scheduled && dataNotAvailable" class="mainText">
                    <div>{{'Discover.distributionReport.reportPlaceholder.sent.details.dataNotAvailable' | localize}}</div>
                </div>
            </ng-container>
            <ng-container *ngIf="isRSSFeed">
                <div class="mainText">{{ 'Briefings.sentReport.rssFeed.noData' | localize}}</div>
            </ng-container>
        </div>
        <agpr-panel
            *ngIf="recipientTotal"
            class="agpr-reportPlaceholder-panel"
            [toggleable]="false"
        ></agpr-panel>
        <agpr-button
            *ngIf="recipientTotal"
            class="agpr-reportPlaceholder-pendingRecipients"
            [style]="buttonTypes.tertiary"
            [label]="'Discover.distributionReport.button.pendingRecipients'| localize : {count: recipientTotal | number}"
            (click)="selectStatType(statTypes.SENT)"
        ></agpr-button>
    </div>
} @else {
    <ng-container>
        <agpr-panel
            [toggleable]="false"
            class="agpr-recipientReport-panel"
        >
            <ng-template #panelHeader>
                <h4 class="agpr-recipientReport-panelHeader">
                    <span>
                        {{ 'Discover.distributionReport.recipient.section.allRecipients' | localize }}
                    </span>
                    <span>
                        {{ recipientReportData.recipientCount | number }}
                    </span>
                </h4>
            </ng-template>
            <agpr-message
                *ngIf="!openTracking"
                [severity]="messageSeverities.info"
            >
                <span>{{ 'Discover.distributionReport.tracking.openDisabled' | localize }}</span>
            </agpr-message>
            <agpr-message
                *ngIf="!clickTracking"
                [severity]="messageSeverities.info"
            >
                <span>{{ 'Discover.distributionReport.tracking.clickDisabled' | localize }}</span>
            </agpr-message>
            <div class="agpr-recipientReport-sentRow">
                <div class="agpr-recipientReport-sentRow-sentTo">
                    <div class="agpr-recipientReport-sentRow-title">{{ 'Discover.distributionReport.recipient.sentTo' | localize }}</div>
                    <div class="agpr-recipientReport-sentRow-value"> {{recipientReportData.sentCount | number}} </div>
                </div>
                <div class="agpr-recipientReport-sentRow-sentDate">
                    <div class="agpr-recipientReport-sentRow-sentDate-title">{{ 'Discover.distributionReport.recipient.sentDate' | localize }}</div>
                    <div class="agpr-recipientReport-sentRow-value"> {{sentDate | changeTimeZone: userTimeZone: 'MMMM D, YYYY h:mm A z'}} </div>
                </div>
            </div>
            <div class="agpr-recipientReport-mainChartRow">
                <div
                    class="agpr-recipientReport-chart-container"
                    [ngClass]="{'agpr-recipientReport-chart-container-selected' :
                        selectedType === statTypes.DELIVERED && !selectedIndividualRecipient
                    }"
                    (agprClickUnless)="selectStatType(statTypes.DELIVERED)"
                    tabindex="0"
                    (keydown)="statCardKeydown($event, statTypes.DELIVERED)"
                >
                    <h5 class="agpr-recipientReport-chart-typeLabel">
                        {{'Discover.distributionReport.recipient.statsType.delivered' | localize}}
                    </h5>
                    <div
                        class="agpr-recipientReport-chart-typeCount"
                        [ngClass]="{'agpr-recipientReport-chart-typeCount-mppEstimated': _enableMppEstimates}"
                    >{{recipientReportData.deliveredCount | number}}</div>
                    <agpr-chart
                        [chart]="deliveredChart"
                    >
                    </agpr-chart>
                    @if (recipientReportData.deliveredRatioPercentageChangeFromBenchmark) {
                        <div
                            [ngClass]="{
                                'agpr-recipientReport-chart-benchmarkDifference': true,
                                'agpr-recipientReport-chart-benchmarkDifference--positive': data.deliveredCount,
                                'agpr-recipientReport-chart-benchmarkDifference--negative': data.deliveredCount < 0,
                                'agpr-recipientReport-chart-benchmarkDifference--neutral': data.deliveredCount === 0 || data.deliveredCount === null
                            }"
                            [agprTooltip]="data.deliveredTooltip"
                        >
                            <span *ngIf="data.deliveredCount > 0" class="fa-arrow-up-right  fa-regular"></span>
                            <span *ngIf="data.deliveredCount < 0" class="fa-arrow-down-right  fa-regular"></span>
                            <span>{{data.deliveredCount + ' %'}}</span>
                        </div>
                    }
                </div>
                <div
                    class="agpr-recipientReport-chart-container"
                    [ngClass]="{'agpr-recipientReport-chart-container-selected' :
                        selectedType === statTypes.UNIQUE_OPEN && !selectedIndividualRecipient
                    }"
                    (agprClickUnless)="openTracking && selectStatType(statTypes.UNIQUE_OPEN)"
                    [pTooltip]="openTracking ? null : ('Discover.distributionReport.tracking.openDisabled' | localize)"
                    tabindex="0"
                    (keydown)="statCardKeydown($event, statTypes.UNIQUE_OPEN)"
                >
                    <h5
                        class="agpr-recipientReport-chart-typeLabel"
                    >
                        {{'Discover.distributionReport.recipient.statsType.uniqueOpens' | localize}}
                    </h5>
                    <div
                        class="agpr-recipientReport-chart-typeCount"
                        [ngClass]="{'agpr-recipientReport-chart-typeDisabled': !openTracking}"
                    >
                        <span *ngIf="!openTracking">{{ 'N/A' | localize }}</span>
                        <span *ngIf="openTracking">{{uniqueOpensCount | number}}</span>
                    </div>
                    <div
                        *ngIf="_enableMppEstimates"
                        class="agpr-recipientReport-chart-estimated"
                    >
                        <span
                            [pTooltip]="'Discover.distribution.statistics.estimatedHover' | localize"
                        >
                            {{'Discover.distribution.statistics.estimated' | localize }}
                        </span>
                    </div>
                    <agpr-chart
                        [chart]="openChart"
                    >
                    </agpr-chart>
                     @if (recipientReportData.uniqueOpenRatioPercentageChangeFromBenchmark) {
                        <div [ngClass]="{
                                    'agpr-recipientReport-chart-benchmarkDifference': true,
                                    'agpr-recipientReport-chart-benchmarkDifference--positive': recipientReportData.uniqueOpenRatioPercentageChangeFromBenchmark > 0,
                                    'agpr-recipientReport-chart-benchmarkDifference--negative': recipientReportData.uniqueOpenRatioPercentageChangeFromBenchmark < 0,
                                    'agpr-recipientReport-chart-benchmarkDifference--neutral': recipientReportData.uniqueOpenRatioPercentageChangeFromBenchmark  === 0 || recipientReportData.uniqueOpenRatioPercentageChangeFromBenchmark  === null
                                }" [agprTooltip]="data.openTooltip | localize">
                            <span *ngIf="recipientReportData.uniqueOpenRatioPercentageChangeFromBenchmark > 0"
                                class="fa-arrow-up-right fa-regular"></span>
                            <span *ngIf="recipientReportData.uniqueOpenRatioPercentageChangeFromBenchmark < 0"
                                class="fa-arrow-down-right fa-regular"></span>
                            <span>{{ recipientReportData.uniqueOpenRatioPercentageChangeFromBenchmark + ' %'}}</span>
                        </div>
                    }
                </div>
                <div
                    class="agpr-recipientReport-chart-container"
                    [ngClass]="{'agpr-recipientReport-chart-container-selected' :
                        selectedType === statTypes.UNIQUE_CLICKS && !selectedIndividualRecipient
                    }"
                    (agprClickUnless)="clickTracking && selectStatType(statTypes.UNIQUE_CLICKS)"
                    [pTooltip]="clickTracking ? null : ('Discover.distributionReport.tracking.clickDisabled' | localize)"
                    tabindex="0"
                    (keydown)="statCardKeydown($event, statTypes.UNIQUE_CLICKS)"
                >
                    <h5 class="agpr-recipientReport-chart-typeLabel">
                        {{'Discover.distributionReport.recipient.statsType.uniqueClicks' | localize}}
                    </h5>
                    <div
                        class="agpr-recipientReport-chart-typeCount"
                        [ngClass]="{
                            'agpr-recipientReport-chart-typeDisabled': !clickTracking,
                            'agpr-recipientReport-chart-typeCount-mppEstimated': _enableMppEstimates
                        }"
                    >
                        <span *ngIf="!clickTracking">{{ 'N/A' | localize }}</span>
                        <span *ngIf="clickTracking">{{recipientReportData.uniqueClickCount | number}}</span>
                    </div>
                    <agpr-chart
                        [chart]="clickChart"
                    >
                    </agpr-chart>
                    @if (recipientReportData.uniqueClickRatePercentageChangeFromBenchmark) {
                        <div
                        [ngClass]="{
                            'agpr-recipientReport-chart-benchmarkDifference': true,
                            'agpr-recipientReport-chart-benchmarkDifference--positive': recipientReportData.uniqueClickRatePercentageChangeFromBenchmark > 0,
                            'agpr-recipientReport-chart-benchmarkDifference--negative': recipientReportData.uniqueClickRatePercentageChangeFromBenchmark < 0,
                            'agpr-recipientReport-chart-benchmarkDifference--neutral': recipientReportData.uniqueClickRatePercentageChangeFromBenchmark  === 0 || recipientReportData.uniqueClickRatePercentageChangeFromBenchmark  === null
                        }"
                        [agprTooltip]="data.clickTooltip | localize"
                        >
                            <span *ngIf="recipientReportData.uniqueClickRatePercentageChangeFromBenchmark > 0" class="fa-arrow-up-right fa-regular"></span>
                            <span *ngIf="recipientReportData.uniqueClickRatePercentageChangeFromBenchmark < 0" class="fa-arrow-down-right fa-regular"></span>
                            <span>{{ recipientReportData.uniqueClickRatePercentageChangeFromBenchmark + ' %'}}</span>
                        </div>
                    }
                </div>
                @if (dataConnectionService.hasEmailAccountProvision$ | async) {
                    <div
                        class="agpr-recipientReport-chart-container"
                        [ngClass]="{'agpr-recipientReport-chart-container-selected' :
                            selectedType === statTypes.REPLY && !selectedIndividualRecipient
                        }"
                        (agprClickUnless)="selectStatType(statTypes.REPLY)"
                        tabindex="0"
                        (keydown)="statCardKeydown($event, statTypes.REPLY)"
                    >
                        <h5 class="agpr-recipientReport-chart-typeLabel">
                            {{'Discover.distributionReport.recipient.statsType.replies' | localize}}
                        </h5>
                        <div class="agpr-recipientReport-chart-typeCount">{{recipientReportData.replyCount | number}}</div>
                        <agpr-chart
                            [chart]="replyChart"
                        >
                        </agpr-chart>
                    </div>
                } @else {
                    <div
                        class="agpr-recipientReport-chart-container agpr-recipientReport-chart-container--disabled"
                    >
                        <h5 class="agpr-recipientReport-chart-typeLabel">
                            {{'Discover.distributionReport.recipient.statsType.replies' | localize}}
                        </h5>
                        <h5 class="agpr-recipientReport-chart-typeDisabled">
                            <i>{{'Core.emailAccount.disabled.notAvailable' | localize}}</i>
                        </h5>
                        <agpr-button
                            label="Core.upsellInfoDialog.learnMore"
                            [style]="buttonTypes.primary"
                            (click)="navigateToLearnMore()"
                        ></agpr-button>
                    </div>
                }
            </div>
            <agpr-undesirables-report
                [data]="recipientReportData"
                [openTracking]="openTracking"
                (statTypeSelected)="selectStatType($event.statType, $event.data)"
                [selectedIndividualRecipient]='selectedIndividualRecipient'
            ></agpr-undesirables-report>
            @if (isDistribution && hasNegativeOutcome) {
                <agpr-message
                    class="agpr-recipientReport-warningMessage"
                    [severity]="messageSeverities.warning"
                    [bottomMargin]="false"
                >
                    <div>
                        {{ 'Discover.distributionReport.recipient.negativeOutcome.warningMessage.text1' | localize : {
                            count: recipientReportData.unsubscribed +
                            recipientReportData.previousUnsubscribe +
                            recipientReportData.hardBounced +
                            recipientReportData.previousHardBounced +
                            recipientReportData.spamReport
                            | number
                        } }}
                    </div>
                    <div>
                        <span>
                            {{'Discover.distributionReport.recipient.negativeOutcome.warningMessage.text2' | localize}}
                        </span>
                        <agpr-button
                            [style]="buttonTypes.link"
                            [underline]="true"
                            [uppercase]="false"
                            label="Discover.distributionReport.recipient.negativeOutcome.warningMessage.link"
                            (click)="openRemoveFromListsDialog()"
                        ></agpr-button>
                    </div>
                </agpr-message>
            }
        </agpr-panel>
        <ng-container>
            <agpr-panel
                *ngIf="listTotalRecipients > 0"
                [toggleable]="false"
                [contentPadding]="false"
            >
                <ng-template #panelHeader>
                    <h4 class="agpr-recipientReport-panelHeader">
                        <span>
                            {{ 'Discover.distributionReport.recipient.section.lists' | localize }}
                        </span>
                        <span>{{listTotalRecipients}}</span>
                    </h4>
                </ng-template>
                <agpr-individual-recipient-report
                    *ngFor="let data of listRecipientData"
                    [data]="data"
                    [openTracking]="openTracking"
                    [clickTracking]="clickTracking"
                    [selectedIndividualRecipient]='selectedIndividualRecipient'
                    (statTypeSelected)="selectStatType($event.statType, $event.data)"
                ></agpr-individual-recipient-report>
            </agpr-panel>
            <agpr-panel
                *ngIf="rrTotalRecipients > 0"
                [toggleable]="false"
            >
                <ng-template #panelHeader>
                    <h4 class="agpr-recipientReport-panelHeader">
                        <span>
                            {{ 'Discover.distributionReport.recipient.section.prCoPilot' | localize }}
                        </span>
                        <span>
                            {{ rrTotalRecipients | number }}
                        </span>
                    </h4>
                </ng-template>
                <agpr-individual-recipient-report
                    *ngFor="let data of rrRecipientData"
                    [data]="data"
                    [openTracking]="openTracking"
                    [clickTracking]="clickTracking"
                    [selectedIndividualRecipient]='selectedIndividualRecipient'
                    (statTypeSelected)="selectStatType($event.statType, $event.data)"
                ></agpr-individual-recipient-report>
            </agpr-panel>
            <agpr-panel
                *ngIf="searchTotalRecipients > 0"
                [toggleable]="false"
            >
                <ng-template #panelHeader>
                    <h4 class="agpr-recipientReport-panelHeader">
                        <span>
                            {{ 'Discover.distributionReport.recipient.section.searches' | localize }}
                        </span>
                        <span>
                            {{ searchTotalRecipients | number }}
                        </span>
                    </h4>
                </ng-template>
                <agpr-individual-recipient-report
                    *ngFor="let data of searchRecipientData"
                    [data]="data"
                    [openTracking]="openTracking"
                    [clickTracking]="clickTracking"
                    [selectedIndividualRecipient]='selectedIndividualRecipient'
                    (statTypeSelected)="selectStatType($event.statType, $event.data)"
                ></agpr-individual-recipient-report>
            </agpr-panel>
            <agpr-panel
                *ngIf="additionalTotalRecipients > 0"
                [toggleable]="false"
            >
                <ng-template #panelHeader>
                    <h4 class="agpr-recipientReport-panelHeader">
                        <span>
                            {{ 'Discover.distributionReport.recipient.section.additional' | localize }}
                        </span>
                        <span>
                            {{ additionalTotalRecipients | number }}
                        </span>
                    </h4>
                </ng-template>
                <agpr-individual-recipient-report
                    *ngFor="let data of additionalRecipientData"
                    [data]="data"
                    [openTracking]="openTracking"
                    [clickTracking]="clickTracking"
                    [selectedIndividualRecipient]='selectedIndividualRecipient'
                    (statTypeSelected)="selectStatType($event.statType, $event.data)"
                ></agpr-individual-recipient-report>
            </agpr-panel>
        </ng-container>
    </ng-container>
}



